var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ob1-popin-modal2",
    { attrs: { id: _vm.modalId, "aria-labelledby": _vm.modalId } },
    [
      _vm.displayPxf && _vm.displayCb4x
        ? _c("ob1-page-menu", {
            staticClass: "mb-3",
            attrs: { tabs: _vm.getTabs() },
            on: { "ob1-page-menu-click": _vm.switchTab },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.displayCb4xContent,
              expression: "displayCb4xContent",
            },
          ],
        },
        [_vm._t("cb4x-content")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.displayCb4xContent,
              expression: "!displayCb4xContent",
            },
          ],
        },
        [_vm._t("pxf-content")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }